import { IsString, IsEmail, IsBoolean } from "class-validator";
import { Type, Expose } from "class-transformer";
import { AuthActiveUserDTO } from "./active-user";

export class AuthLoginInputDTO {
	@IsEmail()
	email: string;

	@IsString()
	password: string;
}

export class AuthLoginOutDTO {

    @Expose()
    success: boolean

    @Expose()
    @Type(() => AuthActiveUserDTO)
    account?: AuthActiveUserDTO;

    @Expose()
    errors?: {
        invalidCredentials?: boolean
    }
}
